import { render, staticRenderFns } from "./products_slideshow.vue?vue&type=template&id=32f49a3c&scoped=true&"
import script from "./products_slideshow.vue?vue&type=script&lang=js&"
export * from "./products_slideshow.vue?vue&type=script&lang=js&"
import style0 from "./products_slideshow.vue?vue&type=style&index=0&id=32f49a3c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32f49a3c",
  null
  
)

export default component.exports